import createFirstWalletBannerSelector from './create-first-wallet-banner.js'
import walletBanners from './wallet-banners.js'
import dappsFromWalletBanners from './dapps-from-wallet-banners.js'

export default [createFirstWalletBannerSelector, walletBanners, dappsFromWalletBanners]
